/* tslint:disable */
/* eslint-disable */
/**
 * 
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { ControlCouponDiscount } from './ControlCouponDiscount';
import {
    ControlCouponDiscountFromJSON,
    ControlCouponDiscountFromJSONTyped,
    ControlCouponDiscountToJSON,
} from './ControlCouponDiscount';
import type { ControlLineItem } from './ControlLineItem';
import {
    ControlLineItemFromJSON,
    ControlLineItemFromJSONTyped,
    ControlLineItemToJSON,
} from './ControlLineItem';

/**
 * 
 * @export
 * @interface ControlProductPurchaseLinkRequest
 */
export interface ControlProductPurchaseLinkRequest {
    /**
     * 
     * @type {string}
     * @memberof ControlProductPurchaseLinkRequest
     */
    success_url: string;
    /**
     * 
     * @type {Array<ControlLineItem>}
     * @memberof ControlProductPurchaseLinkRequest
     */
    line_items?: Array<ControlLineItem>;
    /**
     * 
     * @type {ControlCouponDiscount}
     * @memberof ControlProductPurchaseLinkRequest
     */
    discount?: ControlCouponDiscount;
    /**
     * 
     * @type {string}
     * @memberof ControlProductPurchaseLinkRequest
     */
    locale?: string;
    /**
     * 
     * @type {string}
     * @memberof ControlProductPurchaseLinkRequest
     */
    product_id?: string;
    /**
     * 
     * @type {number}
     * @memberof ControlProductPurchaseLinkRequest
     */
    quantity?: number;
}

/**
 * Check if a given object implements the ControlProductPurchaseLinkRequest interface.
 */
export function instanceOfControlProductPurchaseLinkRequest(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "success_url" in value;

    return isInstance;
}

export function ControlProductPurchaseLinkRequestFromJSON(json: any): ControlProductPurchaseLinkRequest {
    return ControlProductPurchaseLinkRequestFromJSONTyped(json, false);
}

export function ControlProductPurchaseLinkRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): ControlProductPurchaseLinkRequest {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'success_url': json['success_url'],
        'line_items': !exists(json, 'line_items') ? undefined : ((json['line_items'] as Array<any>).map(ControlLineItemFromJSON)),
        'discount': !exists(json, 'discount') ? undefined : ControlCouponDiscountFromJSON(json['discount']),
        'locale': !exists(json, 'locale') ? undefined : json['locale'],
        'product_id': !exists(json, 'product_id') ? undefined : json['product_id'],
        'quantity': !exists(json, 'quantity') ? undefined : json['quantity'],
    };
}

export function ControlProductPurchaseLinkRequestToJSON(value?: ControlProductPurchaseLinkRequest | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'success_url': value.success_url,
        'line_items': value.line_items === undefined ? undefined : ((value.line_items as Array<any>).map(ControlLineItemToJSON)),
        'discount': ControlCouponDiscountToJSON(value.discount),
        'locale': value.locale,
        'product_id': value.product_id,
        'quantity': value.quantity,
    };
}

